import { PoolerUser } from '../../models/user';
import { Customer } from '../../models/customer';

export function getEmploymentJoinAndLeaveDateQuery(
  user: PoolerUser,
  customer: Customer,
): { $or: Record<string, any>[] } | undefined {
  const joinDate = user.customerInformation?.[customer._id]?.joinDate;
  const leaveDate = user.customerInformation?.[customer._id]?.leaveDate;
  if (!leaveDate && !joinDate) {
    return;
  }
  if (joinDate && leaveDate && joinDate > leaveDate) {
    return {
      $or: [
        {
          endDate: {
            $lte: leaveDate,
          },
        },
        {
          startDate: {
            $gte: joinDate,
          },
        },
      ],
    };
  } else {
    const $orQuery: Record<string, any>[] = [];
    if (joinDate) {
      $orQuery.push({
        startDate: {
          $gte: joinDate,
        },
      });
    }
    if (leaveDate) {
      $orQuery.push({
        endDate: {
          $lte: leaveDate,
        },
      });
    }
    return {
      $or: $orQuery,
    };
  }
}
